import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminSolar_connectionsHealth = z.any()
export type TagsGetAdminSolar_connectionsHealth = z.infer<typeof tagsGetAdminSolar_connectionsHealth>

export const responseGetAdminSolar_connectionsHealth = z.object({ "payload": z.object({ "config": z.object({ "pollIntervalSeconds": z.number(), "requestTimeoutMs": z.number(), "concurrency": z.number(), "retries": z.number(), "autoPauseHours": z.number(), "rawRetentionDays": z.number(), "solaxHost": z.string() }), "healthy": z.boolean(), "workers": z.array(z.object({ "id": z.string(), "heartbeatAt": z.string().datetime({ offset: true }), "startedAt": z.string().datetime({ offset: true }), "healthy": z.boolean(), "config": z.object({ "pollIntervalSeconds": z.number(), "requestTimeoutMs": z.number(), "concurrency": z.number(), "retries": z.number(), "autoPauseHours": z.number(), "rawRetentionDays": z.number(), "solaxHost": z.string() }) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminSolar_connectionsHealth = z.infer<typeof responseGetAdminSolar_connectionsHealth>

interface IGetAdminSolar_connectionsHealth extends BaseMethodType {
  tags: TagsGetAdminSolar_connectionsHealth,
  response: ResponseGetAdminSolar_connectionsHealth
}
export const URL = '/admin/solar-connections/health'
export const validation = {
  get: {
    tags: tagsGetAdminSolar_connectionsHealth,
    response: responseGetAdminSolar_connectionsHealth
  }
}
export interface AdminSolar_connectionsHealth extends BaseRouteType {
  get: IGetAdminSolar_connectionsHealth
}